import { Card } from "@/components/ui/Card";
import RoleTableView from "./component/table";
import useDocumentTitle from "@/hooks/UseDocumentTitle";

const RolesAndAccess = () => {
  useDocumentTitle("Role & Access Management");
  
  return (
    <div className="w-full p-5">
      <Card>
        <RoleTableView />
      </Card>
    </div>
  );
};

export default RolesAndAccess;
